// Sub-component rendering the rich text description.
import { Box, Button, Typography } from '@mui/material';
import { createSafeHtml } from '@/features/tasks/utils/data/htmlUtils';
import { useT } from '@/i18n/useT';

const TaskDescription = ({
  description,
  date,
  time,
  isExpanded,
  setIsExpanded,
  isOverflowing,
  descriptionRef,
}) => {
  const t = useT();

  return (
    <Box>
      {description ? (
        <Box
          ref={descriptionRef}
          className="tiptap-editor-content"
          sx={
            !isExpanded
              ? {
                  maxHeight: 120,
                  maskImage:
                    'linear-gradient(to bottom, #000 70%, transparent)',
                  overflow: 'hidden',
                }
              : {}
          }
          dangerouslySetInnerHTML={{ __html: createSafeHtml(description) }}
        />
      ) : (
        <Typography
          sx={{
            color: 'text.secondary',
            fontStyle: 'italic',
            whiteSpace: 'pre-wrap',
            m: 0,
          }}
        >
          {t('task.noDescription', 'No description')}
        </Typography>
      )}
      {isOverflowing ? (
        <Button
          onClick={() => setIsExpanded(!isExpanded)}
          size="small"
          color="secondary"
        >
          {isExpanded
            ? t('task.showLess', 'Show Less')
            : t('task.showMore', 'Show More')}
        </Button>
      ) : null}
      {date || time ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mt: 1 }}>
          {date ? (
            <Typography variant="body2">
              <strong>{t('task.date', 'Date:')}</strong> <span>{date}</span>
            </Typography>
          ) : null}
          {time ? (
            <Typography variant="body2">
              <strong>{t('task.time', 'Time:')}</strong> <span>{time}</span>
            </Typography>
          ) : null}
        </Box>
      ) : null}
    </Box>
  );
};

export default TaskDescription;
